/* eslint-disable no-param-reassign */
import axios, { AxiosError, AxiosResponse } from 'axios';
import { getAccessToken } from '../utils/cookies';
import { baseUrl } from './variables';

const init = (): void => {
  axios.defaults.baseURL = baseUrl;
  axios.interceptors.request.use((config) => {
    const tokenConfig = config.headers.Authorization;
    const token = tokenConfig ? `Bearer ${tokenConfig}` : getAccessToken();
    config.headers.Authorization = token;
    config.headers.Accept = 'application/json';
    config.headers['Content-Type'] = 'application/json';
    return config;
  });

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      const { error } = response.data;
      if (error) {
        return Promise.reject(response.data);
      }
      return response;
    },
    (error: AxiosError) => Promise.reject(error),
  );
};

export default init;
